import { createSlice } from '@reduxjs/toolkit';

import {
  createUserDashboardPreferences,
  deleteUserDashboardPreferences,
  fetchUser,
  fetchUserDashboardPreferences,
  fetchUserTableSettings,
  upsertTablePageSize
} from '../actions/userSlice';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    dashboardPreferences: null,
    error: null,
    isAdmin: false,
    loading: true,
    permissions: [],
    tableSettings: [],
    user: {}
  },
  extraReducers: builder => {
    builder
      // Create User Dashboard Preferences
      .addCase(createUserDashboardPreferences.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createUserDashboardPreferences.fulfilled, (state, action) => {
        state.dashboardPreferences = action.payload?.widgets?.data;
        state.loading = false;
      })
      .addCase(createUserDashboardPreferences.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Current User
      .addCase(fetchUser.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.isAdmin = action.payload.isAdmin;
        state.permissions = action.payload.permissions;
        state.loading = false;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch User Dashboard Preferences
      .addCase(fetchUserDashboardPreferences.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserDashboardPreferences.fulfilled, (state, action) => {
        state.dashboardPreferences = action.payload?.widgets?.data;
        state.loading = false;
      })
      .addCase(fetchUserDashboardPreferences.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch User Table Settings
      .addCase(fetchUserTableSettings.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserTableSettings.fulfilled, (state, action) => {
        state.tableSettings = action.payload;
        state.loading = false;
      })
      .addCase(fetchUserTableSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Upsert User Table Settings
      .addCase(upsertTablePageSize.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(upsertTablePageSize.fulfilled, (state, action) => {
        state.tableSettings = action.payload;
        state.loading = false;
      })
      .addCase(upsertTablePageSize.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Reset User Dashboard Preferences
      .addCase(deleteUserDashboardPreferences.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteUserDashboardPreferences.fulfilled, (state, action) => {
        state.dashboardPreferences = null;
        state.loading = false;
      })
      .addCase(deleteUserDashboardPreferences.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default userSlice.reducer;
